<template>
  <div class="locked text-upper flex-center">
    <i class="n-i n-i-lock-a" />
    <span>{{ status | translate }}</span>
  </div>
</template>

<script>
export default {
  name: 'MatchLocked',
  props: {
    matchStatusPeriod: {
      required: true,
      type: String,
    },
  },
  computed: {
    status() {
      let status;

      switch (this.matchStatusPeriod) {
        case 'ENDED':
          status = 'matchFinished';
          break;
        case 'NOT_STARTED':
          status = 'matchStartingSoon';
          break;
        case 'INTERRUPTED':
          status = 'matchInterrupted';
          break;
        default:
          status = 'matchLocked';
      }

      return status;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.locked {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  font-size: 0.625rem;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: $match-bet-vertical-line-width;
    background-color: $match-bet-vertical-line-color-back;
  }

  i { padding-right: 10px; }
}
</style>
